module.exports = __webpack_public_path__ + "img/zhifubao.dd58ec2e.png";